// extracted by mini-css-extract-plugin
export default {"layoutContainer":"Layout_layoutContainer__A+Btx","mainContent":"Layout_mainContent__Bq4qw"};